import { Injectable } from '@angular/core';
import flagColors from '../flags.json';
import {FlagColor} from '../data/flagColor';

@Injectable({
  providedIn: 'root'
})
export class FlagService {

  flagColors = flagColors.colors;
  flagColorKeys = Object.keys(flagColors.colors);

  constructor() { }

  getColor(color: FlagColor): string {
    return this.flagColors[this.flagColorKeys[color]];
  }
}
